import React from "react";
import {useTranslation} from "react-i18next"

import {IonItem, IonItemSliding, IonLabel, IonList} from "@ionic/react"

import {PersonGroup as ItemType}    from "../../../types/PersonGroup"

import Person from "../../../types/Person";

import ListItem              from "./ListItem";
import ItemSegmentListHeader from "../../common/Headers/ItemSegmentListHeader";

interface props {
    item: ItemType
}

const List: React.FC<props> = ({ item }) => {

    const { t } = useTranslation()

    const listPeople = (people: Person[]) => {
        if (people.length === 0) {
            return (
                <IonItem className="ion-text-center">
                    <IonLabel className="ion-text-wrap">
                        {t('person-groups.no_people_for_person_group')}
                    </IonLabel>
                </IonItem>
            )
        }

        return people.map((person: Person) => {
            return (
                <IonItemSliding className={person.isHidden ? 'hidden-by-default' : ''}
                                key={"item-sliding-key-person-" + person.id}>
                    <ListItem personGroup={item} person={person} />
                </IonItemSliding>
            )
        })
    }

    const title: string    = item?.name || '-'
    const subTitle: string = item?.description || '-'

    return (
        <>
            <IonList lines="full" className="maxWidth">
                <ItemSegmentListHeader title={title} subTitle={subTitle} />
                {listPeople(item.people || [])}
            </IonList>
        </>
    )
}

export default List